import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  AllFabricATSInquiryCriteriaBean,
  AllFabricStyleATSInfoDetailsPrintRequest,
  CustomerLogisticOnOrderSearchCriteria,
  CustomerOnOrderATSSummaryDetailsRequest,
  CustomerSalesOnOrderSearchCriteria,
  FabricStyleBean,
  FabricStyleCurrentATSInfoBean,
  FabricStyleInventoryDataBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  FabricStyleStatisticsInquiryCriteriaBean,
  ItemCatalogInputCriteria,
  ItemCatalogInquiryDetailsRequest,
  ManualInventoryCustomerAllocationSearchCriteria,
  RestCustomerSalesOnOrderListRequest,
  RestFabricStyleATSListRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleStatisticsInquiryListRequest,
  RestManualInventoryCustomerAllocationListRequest,
  RestPageListBean,
  RestPurchaseOrderInTransitListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  RestVendorPurchaseOnOrderListRequest,
  SKUBatchInventorySearchCriteria,
  SkuBatchInventorySummaryDetailsPrintRequest,
  VendorOnOrderPrintRequest,
  VendorPurchaseOnOrderSearchCriteria,
  VendorSummaryOnOrderATSDetailsRequest,
  PageListBean,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupLogisticOrderModule,
  PopupPurchaseInTransitModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class ATSInquiryModule extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.itemlistCodeRef = React.createRef();
    this.state = {
      onHandQtyDataList: [],
      onHandQtySummaryDataList: [],
      customerQtyDataList: [],
      LogisticQtyDataList: [],
      customerSummaryDataList: [],
      logisticSummaryDatalist: [],
      vendorQtyDataList: [],
      sourceSalesOrderDataList: [],
      vendorSummaryDataList: [],
      vendorInTransitQtyDataList: [],
      vendorInTransitSummaryDataList: [],
      showHide: this.props.showHide,
      pageTitle: "All Fabric ATS-Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: true,
      isShowExcelButton: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowItemCatelogButton: false,
      isShowPoInputExcelButton: false,
      isShowExitButton: true,
      isShowVendorCodeModule: false,
      error_list: [],
      inquiryDataList: [],
      alertMessage: "",
      summaryData: null,
      criteria: new AllFabricATSInquiryCriteriaBean(),
      inventoryDataBean: new FabricStyleInventoryDataBean(),
      fabricAtsInfoBean: new FabricStyleCurrentATSInfoBean(),
      fabricVendorAtsInfoBean: new FabricStyleCurrentATSInfoBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      item_list: [],
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseInTransitModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      isShowOnHandQtyPopup: false,
      isShowOnHandQtySummaryPopup: false,
      isShowCustomerQtyPopup: false,
      isShowLogisticQtyPopup: false,
      isShowCustomerSummaryPopup: false,
      isShowLogisticSummaryPopup: false,
      isShowVendorSummaryPopup: false,
      isShowVendorQtyPopup: false,
      isShowVendorInTransitQtyPopup: false,
      isShowVendorInTransitSummaryPopup: false,
      isShowAllLastMonthQtyPopup: false,
      isShowManualAllocatePopup: false,
      isShowMonthToDateQtyData: false,
      isShowlast3MonthQtyData: false,
      isShowlast6MonthQtyData: false,
      isShowlast12MonthQtyData: false,
      isShowlast18MonthQtyData: false,
      isShowlast24MonthQtyData: false,
      isShowlast36MonthQtyData: false,
      lastSalesCriteria: new FabricStyleStatisticsInquiryCriteriaBean(),
      vendorInTransitBean: new FabricStyleCurrentATSInfoBean(),
      monthToDateQtyDataList: [],
      last3MonthQtyDataList: [],
      last6MonthQtyDataList: [],
      last12MonthQtyDataList: [],
      last18MonthQtyDataList: [],
      last24MonthQtyDataList: [],
      last36MonthQtyDataList: [],
      manualAllocateList: [],
      simplePopupContent: [],
      manualAllocateCriteria:
        new ManualInventoryCustomerAllocationSearchCriteria(),
      colorLookupHandler: null,
      isShowColorLookup: false,
      fabricList: new Array(),
      locationList1: new Array(),
      locationList: null,
      fabricDatas: [],
      locationDatas: [],
      locations: [],
      locationData: null,
      isCollapsible_open: true,
      isShowItemCatelogPopup: false,
      colorList: [],
      patternTypeCategories: [],
      fabricStyleData: new FabricStyleBean(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      showAutoCompleteMultiFabricList: true,
      multiFabricPageListForAutoCompleteList: new Array(),
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      categoryTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteCategoryTypeList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      parentProductCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteParentProductCodeList: true,
      isDisableFields: false,
      isTabView: false,
      selectedItemList: [],
      order: "asc",
      sortField: "",
      is3PL: false,
      patternTypeCategories: new Array(),
      warehouses: new Array(),
      itemexcludeCode: "",
      isFabricNotFound: false,
      isMultiFabricNotFound: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (!isEmptyArray(attribute_cache.warehouses)) {
      warehouses.map((attr) => {
        this.state.locations.push(attr);
      });
    }
    let patternTypeCategories = attribute_cache.patternTypeCategories;
    if (!isEmptyArray(attribute_cache.patternTypeCategories)) {
      patternTypeCategories.map((attr) => {
        this.state.patternTypeCategories.push(attr);
      });
    }
    if (this.props.fabricCode !== "" && this.props.fabricCode !== undefined) {
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = this.props.fabricCode;
      if (this.props.fabricName !== "" && this.props.fabricName !== undefined)
        criteria.fabricStyleName = this.props.fabricName;
      this.setState({
        criteria: criteria,
        isTabView: true,
        isShowExitButton: false,
        isShowResetButton: false,
        isShowClearErrorButton: false,
        isDisableBasedOnTabView: false,

        // isShowExecuteButton: false,
      });
      this.loadPage(1);
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readMultiFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByMultiFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByMultiFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      multiFabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  multifabricCodeOnChange = (e) => {
    let itemexcludeCode = e.target.value;
    this.state.showAutoCompleteMultiFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
    if (isEmpty(itemexcludeCode)) {
      this.setState({
        showAutoCompleteMultiFabricList: false,
      });
      let showAutoCompleteList = this.state.showAutoCompleteMultiFabricList;
      let criteria = this.state.criteria;
      // criteria.fabricStyleCode = "";
      criteria.itemexcludeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteMultiFabricList: showAutoCompleteList,
        criteria: criteria,
        multiFabricPageListForAutoCompleteList: suggestion,
        fabricStyleData: null,
        isMultiFabricNotFound: false,
      });
    } else if (
      e.target.name == "itemexcludeCode" &&
      showAutoCompleteList === true &&
      itemexcludeCode !== ""
    ) {
      this.readMultiFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.itemexcludeCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    } else {
      this.fabricFound(2);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  onParentProductCodeChange = (e) => {
    let parentProductCode = e.target.value;
    this.state.showAutoCompleteParentProductCodeList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteParentProductCodeList;
    if (isEmpty(parentProductCode)) {
      this.state.showAutoCompleteParentProductCodeList = false;
      let showAutoCompleteList =
        this.state.showAutoCompleteParentProductCodeList;
      let criteria = this.state.criteria;
      criteria.parentProductCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteParentProductCodeList: showAutoCompleteList,
        criteria: criteria,
        parentProductCodePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "parentProductCode" &&
      showAutoCompleteList === true &&
      parentProductCode !== ""
    ) {
      this.readParentProductCodeBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readParentProductCodeBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByParentProductCodeResponse,
      this.errorCallBack
    );
  }
  readByParentProductCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      parentProductCodePageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readandsetParentProductCodeDetail = (parentProductCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = parentProductCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetParentProductCodeDetailResponse,
      this.errorCallBack
    );
  };
  readandsetParentProductCodeDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.parentProductCode = fabricStyle.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  parentProductCodeEnterKeyEventHandler = (e) => {
    this.readandsetParentProductCodeDetail(e.target.value);
    this.setState({
      parentProductCodePageListForAutoCompleteList: new Array(),
    });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.props.is3PL ? "read Item" : "read Fabric",
    });
  };
  displayAutoCompleteParentProductCodeList = (
    showAutoCompleteParentProductCodeList
  ) => {
    this.setState({
      showAutoCompleteParentProductCodeList:
        showAutoCompleteParentProductCodeList,
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
        isFabricNotFound: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    // this.readandsetFabricStyleDetail(fabricStyleCode);
  };
  fabricOnKeydown = (e) => {
    let criteria = this.state.criteria;
    criteria.fabricStyleCode = e.target.value;
    this.state.criteria = criteria;
    if (e.keyCode == 9) {
      let valid = this.fabricFound(1);
      if (!valid) {
        this.readandsetFabricStyleDetail(e.target.value.toUpperCase());
      }
    }
  };
  multiFabricOnKeydown = (e) => {
    let criteria = this.state.criteria;
    criteria.itemexcludeCode = e.target.value;
    this.state.criteria = criteria;
    if (e.keyCode == 9) {
      let valid = this.fabricFound(2);
      if (!valid) {
        this.readFabricStyle(e.target.value.toUpperCase());
      }
    }
  };
  fabricFound = (type) => {
    let criteria = this.state.criteria;
    let errMsg = "";
    let errList = [];
    let valid = false;
    if (type == 1) {
      let fabricList = this.state.fabricPageListForAutoCompleteList.filter(
        (ln) => ln.code == criteria.fabricStyleCode.toUpperCase()
      );
      let fabricStyleCode = "";
      fabricList.map((ln) => {
        fabricStyleCode = ln.code;
      });

      if (criteria.fabricStyleCode.toUpperCase() != fabricStyleCode) {
        errMsg = "InValid Item";
        errList.push(errMsg);
        this.state.isFabricNotFound = true;
        valid = true;
      }
    } else if (type == 2) {
      let multiFabricList =
        this.state.multiFabricPageListForAutoCompleteList.filter(
          (ln) => ln.code == criteria.itemexcludeCode.toUpperCase()
        );
      let itemexcludeCode = "";
      multiFabricList.map((ln) => {
        itemexcludeCode = ln.code;
      });

      if (criteria.itemexcludeCode.toUpperCase() != itemexcludeCode) {
        errMsg = "InValid Item";
        errList.push(errMsg);
        this.state.isMultiFabricNotFound = true;
        valid = true;
      }
    }
    if (errList.length > 0) {
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    return valid;
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    } else {
      this.fabricFound(1);
      //   let fabricList = this.state.fabricPageListForAutoCompleteList.filter(
      //     (ln) => ln.code == criteria.fabricStyleCode.toUpperCase()
      //   );
      //   let fabricStyleCode = "";
      //   fabricList.map((ln) => {
      //     fabricStyleCode = ln.code;
      //   });

      //   if (criteria.fabricStyleCode.toUpperCase() != fabricStyleCode) {
      //     let errMsg = "InValid Item";
      //     let errList = [];
      //     errList.push(errMsg);

      //     this.setState({
      //       alertMessage: errList,
      //       alertType: "danger",
      //       isShowAlert: true,
      //       isFabricNotFound: true,
      //     });
      //   }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading...",
    });
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.readFabricStyle(e.target.value);
    this.setState({ multiFabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading ...",
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  displayAutoCompleteMultiFabricList = (showAutoCompleteMultiFabricList) => {
    this.setState({
      showAutoCompleteMultiFabricList: showAutoCompleteMultiFabricList,
    });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };

  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  addFabric = () => {
    let criteria = this.state.criteria;
    criteria.itemexcludeCode = "";
    criteria.companyCode = this.companyCode;
    let fabricStyleData = this.state.fabricStyleData;
    let fabricDatas = this.state.fabricDatas;
    if (fabricStyleData != null) {
      if (!isEmptyArray(fabricDatas) && !isEmptyString(fabricStyleData.code)) {
        let exists = fabricDatas.find((p) => p.code === fabricStyleData.code);
        if (!exists) {
          fabricDatas.push(fabricStyleData);
          criteria.excludedFabricCodes = fabricStyleData.code;
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      } else {
        if (!isEmptyString(fabricStyleData.code)) {
          fabricDatas.push(fabricStyleData);
          criteria.excludedFabricCodes = fabricStyleData.code;
          this.setState({
            criteria: criteria,
            fabricDatas: fabricDatas,
            fabricStyleData: new FabricStyleBean(),
          });
        }
      }
    }
  };
  addLocation = () => {
    let criteria = this.state.criteria;
    criteria.locationCode = "";
    criteria.companyCode = this.companyCode;
    let locationData = this.state.locationData;
    let locationDatas = this.state.locationDatas;
    if (locationData != null) {
      if (!isEmptyArray(locationDatas)) {
        let exists = locationDatas.find((p) => p.code === locationData.code);
        if (!exists) {
          locationDatas.push(locationData);
          criteria.excludedLocationCodes.push(locationData.code);
          this.setState({
            criteria: criteria,
            locationDatas: locationDatas,
            locationData: null,
          });
        }
      } else {
        if (!isEmptyString(locationData.code)) {
          locationDatas.push(locationData);
          criteria.excludedLocationCodes.push(locationData.code);
          this.setState({
            criteria: criteria,
            locationDatas: locationDatas,
            locationData: null,
          });
        }
      }
    }
  };
  deleteFabric = (line) => {
    let criteria = this.state.criteria;
    let temp_Code = [];
    let lineData = criteria.excludedFabricCodes;
    let fabricDatas = this.state.fabricDatas;
    fabricDatas.map((list, index) => {
      if (list.code === line.code) {
        fabricDatas.splice(index, 1);
      }
    });
    fabricDatas.map((list) => {
      temp_Code.push(list.code);
    });
    criteria.excludedFabricCodes = temp_Code.toString();
    this.setState({
      criteria: criteria,
      fabricDatas: fabricDatas,
      fabricStyleData: new FabricStyleBean(),
    });
  };
  deleteLocation = (line) => {
    let criteria = this.state.criteria;
    let lineData = criteria.excludedLocationCodes;
    let locationDatas = this.state.locationDatas;
    locationDatas.map((list, index) => {
      if (list.code === line.code) {
        lineData.splice(index, 1);
        locationDatas.splice(index, 1);
      }
    });
    this.setState({ criteria: criteria, locationData: null });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  validateCriteria = (criteria) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (
      isEmptyString(criteria.fabricStyleCode) &&
      isEmptyArray(criteria.excludedFabricCodes)
    ) {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricCode is Required";
      } else {
        errMsg = "ItemCode is Required";
      }
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        isShowAlert: true,
        alertMessage: err_list,
        alertType: "danger",
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    let criteria_Data = this.state.criteria;
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = criteria_Data.fabricStyleCode;
    criteria.fabricStyleColorCode = criteria_Data.fabricStyleColorCode;
    criteria.excludedFabricCodes = criteria_Data.excludedFabricCodes;
    criteria.itemCodeContains = criteria_Data.itemCodeContains;
    criteria.showNonAvailableItemsFlag =
      criteria_Data.showNonAvailableItemsFlag;

    let pageInput = new RestPageListBean();
    // pageInput.pageSize = 50;
    // pageInput.currentPage = pageNumber;
    let listRequest = new RestFabricStyleATSListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    if (!ConfigManager.isAtsLoadedWithOutValidation()) {
      const isValid = this.validateCriteria(criteria);
      if (isValid) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Executing...",
        });
        this.loadFabricAtsInquiryList(listRequest);
      }
    } else {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
      this.loadFabricAtsInquiryList(listRequest);
    }
  };
  loadFabricAtsInquiryList = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.inquireAllFabricStyleATSInfos(
        listRequest,
        this.loadFabricAtsPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadFabricAtsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inquiryResult) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.inquiryResult.atsInfos)) {
        resultList = response.data.inquiryResult.atsInfos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
          isShowItemCatelogButton: true,
        });
        if (!this.state.isTabView) {
          this.setState({
            isShowPoInputExcelButton: true,
          });
        }
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        inquiryDataList: resultList,
        isCollapsible_open: false,
      });
      if (!this.state.isTabView) {
        this.setState({
          isShowResetButton: true,
        });
      }
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCodeStartsWith = "";
    criteria.fabricStyleName = "";
    criteria.fabricStyleCode = "";
    criteria.locationCode = "";
    criteria.itemexcludeCode = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricDatas: [],
      locationDatas: [],
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      locationData: null,
      colorList: [],
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
      itemexcludeCode: "",
      isFabricNotFound: false,
      isMultiFabricNotFound: false,
    });
  };
  resetInquiry = () => {
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCodeStartsWith = "";
    criteria.fabricStyleName = "";
    criteria.itemexcludeCode = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: true,
      isShowExcelButton: true,
      isShowColorLookup: false,
      fabricDatas: [],
      locationDatas: [],
      locationData: [],
      fabricStyleData: [],
      isCollapsible_open: true,
      isShowItemCatelogButton: false,
      isShowPoInputExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      locationData: null,
      colorList: [],
      isDisableFields: false,
      itemexcludeCode: "",
      isFabricNotFound: false,
      isMultiFabricNotFound: false,
    });
    this.hideAlertCallBack();
  };
  poInputExcel = (e) => {
    if (e.detail === 1) this.generateReport(2);
  };
  itemCatelog = (e) => {
    if (e.detail === 1) this.setState({ isShowItemCatelogPopup: true });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    // const criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new AllFabricStyleATSInfoDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.AllFabricATSInquiryPDFReport_IsAccessible()) {
        ReportService.generateAllFabricStyleATSInfoDetailsPrintReport(
          listRequest,
          this.generateFabricATSPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.AllFabricATSInquiryExcelReport_IsAccessible()) {
        ReportService.generateAllFabricStyleATSInfoDetailsPrintReport(
          listRequest,
          this.generateFabricATSPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };

  generateFabricATSPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };  
  generateFabricATSPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };


  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      inventoryDataBean.totalOnHandQuantity = rowData.onHandQuantity;
      inventoryDataBean.uomCode = rowData.uomCode;
      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.fabricStyleColorCode;
      qtyCriteria.isExcludeNonWarehouseInventory = true;
      qtyCriteria.fetchQuantityAvailableLinesOnly = true;
      qtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let exludeReserveInventory =
        ConfigManager.excludeReserveInventoryInATSFlag();
      qtyCriteria.isExcludeReserveWarehouseInventory = exludeReserveInventory;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "fetching OnHand details...",
      });
      if (rowData.onHandQuantity > 0) {
        this.loadOnHandQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No OnHand Qty";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        listRequest,
        this.loadOnHandQtyPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      const onHandQtyList =
        response.data.skuBatchInventoryPageList.skuBatchInventories;
      if (onHandQtyList != null) {
        this.setState({
          onHandQtyDataList: onHandQtyList,
          isShowOnHandQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(1);
  };
  generateOnHandQtyExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(2);
  };
  generateOnHandQtyReport = (reportType) => {
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpItemOnOrderPrintReport(
        listRequest,
        this.generateOnHandQtyResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  else if(reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpItemOnOrderPrintReport(
        listRequest,
        this.generateOnHandQtyResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateOnHandQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateOnHandQtyResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onHandQtySummaryOnClick = (e) => {
    if (e.detail === 1) {
      let inventoryDataBean = this.state.inventoryDataBean;
      let criteria = new SKUBatchInventorySearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
      criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
      criteria.excludeNonWarehouseInventory = true;
      criteria.fetchQuantityAvailableLinesOnly = true;
      let exludeReserveInventory =
        ConfigManager.excludeReserveInventoryInATSFlag();
      criteria.excludeReserveWarehouseInventory = exludeReserveInventory;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching SkuBatch Inventories...",
      });
      if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
        InventoryService.getSKUBatchInventoriesSummary(
          criteria,
          this.loadOnHandQtySummaryResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  loadOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchSummaryResult != null &&
      response.data.skuBatchSummaryResult.inventorySummaryBean != null
    ) {
      const onHandQtySummaryDataList =
        response.data.skuBatchSummaryResult.inventorySummaryBean;
      this.setState({
        onHandQtySummaryDataList: onHandQtySummaryDataList,
        isShowOnHandQtySummaryPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(1);
  };
  generateOnHandQtySummaryExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(2);
  };
  generateOnHandQtySummaryReport = (reportType) => {
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludeNonWarehouseInventory = true;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new SkuBatchInventorySummaryDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
        listRequest,
        this.generateOnHandQtySummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
   if (reportBean.reportType == 2) {
     if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
        listRequest,
        this.generateOnHandQtySummaryResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
   }
  };
  generateOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };


  logisticSummaryOnClick = () => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Summary...",
    });
    this.loadLogisticOrderSummaryPage(criteria);
  };

  loadLogisticOrderSummaryPage = (criteria) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.geCustomerOnOrderATSSummary(
        criteria,
        this.loadLogisticOrderSummaryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadLogisticOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.inquiryResult != null &&
      response.data.inquiryResult.info != null
    ) {
      const logisticSummaryDatalist = response.data.inquiryResult.info;
      this.setState({
        logisticSummaryDatalist: logisticSummaryDatalist,
        isShowLogisticSummaryPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      let errMsg = "No Data Found";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateLogisticSummaryPdf = (e) => {
    if (e.detail === 1) this.generateLogisticSummaryReport(1);
  };
  generateLogisticSummaryExcel = (e) => {
    if (e.detail === 1) this.generateLogisticSummaryReport(2);
  };
  generateLogisticSummaryReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerOnOrderATSSummaryDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
      if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getCustomerOnOrderATSSummaryDetailsReport(
        listRequest,
        this.generateLogisticSummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
      else if (reportBean.reportType == 2) {
         if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getCustomerOnOrderATSSummaryDetailsReport(
        listRequest,
        this.generateLogisticSummaryResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
      }
  };
  generateLogisticSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
generateLogisticSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  generateLogisticOnOrderPdf = () => {
    this.generateLogisticOnOrderReport(1);
  };
  generateLogisticOnOrderExcel = () => {
    this.generateLogisticOnOrderReport(2);
  };
  generateLogisticOnOrderReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new RestCustomerSalesOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
       if (reportBean.reportType == 1) {

    ReportService.downloadPopUpCustomerOnOrderPrintReport(
      listRequest,
      this.generateLogisticOnOrderResponse,
      this.errorCallBack
    );
  }
   else if (reportBean.reportType == 2) {

    ReportService.downloadPopUpCustomerOnOrderPrintReport(
      listRequest,
      this.generateLogisticOnOrderResponseForExcel,
      this.errorCallBack
    );
  }
  };
  generateLogisticOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateLogisticOnOrderResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadLogisticOnOrderQtyListPage = (listRequest) => {
    CustomerService.getCustomerLogisticOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadLogisticOnOrderQtyPageResponse,
      this.errorCallBack
    );
  };
  loadLogisticOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.orderDetailsResult != null &&
      response.data.orderDetailsResult.onOrderInfoDetails != null
    ) {
      const LogisticQtyDataList =
        response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        LogisticQtyDataList: LogisticQtyDataList,
        isShowLogisticQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  logisticOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
      fabricAtsInfoBean.companyCode = this.companyCode;
      fabricAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricAtsInfoBean.fabricStyleName = rowData.fabricStyleName;
      fabricAtsInfoBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      fabricAtsInfoBean.totalCustOnOrderQuantity =
        rowData.logisticOnOrderQuantity;
      this.setState({ fabricAtsInfoBean: fabricAtsInfoBean });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      const criteria = new CustomerLogisticOnOrderSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.colorCode = rowData.fabricStyleColorCode;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading InBound OnOrder detais...",
      });
      if (rowData.logisticOnOrderQuantity != 0) {
        this.loadLogisticOnOrderQtyListPage(criteria);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  customerOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
      fabricAtsInfoBean.companyCode = this.companyCode;
      fabricAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricAtsInfoBean.fabricStyleName = rowData.fabricStyleName;
      fabricAtsInfoBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      fabricAtsInfoBean.totalCustOnOrderQuantity =
        rowData.customerOnOrderQuantity;
      this.setState({ fabricAtsInfoBean: fabricAtsInfoBean });
      let custQtyCriteria = new CustomerSalesOnOrderSearchCriteria();
      custQtyCriteria.companyCode = this.companyCode;
      custQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      custQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      custQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestCustomerSalesOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = custQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Customer OnOrder detais...",
      });
      if (rowData.customerOnOrderQuantity != 0) {
        this.loadCustomerOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadCustomerOnOrderQtyListPage = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      CustomerService.getCustomerSalesOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadCustomerOnOrderQtyPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.orderDetailsResult != null &&
      response.data.orderDetailsResult.onOrderInfoDetails != null
    ) {
      const customerQtyDataList =
        response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        customerQtyDataList: customerQtyDataList,
        isShowCustomerQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCustomerOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateCustomerOnOrderReport(1);
  };
  generateCustomerOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateCustomerOnOrderReport(2);
  };
  generateCustomerOnOrderReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new RestCustomerSalesOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpCustomerOnOrderPrintReport(
        listRequest,
        this.generateCustomerOnOrderResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpCustomerOnOrderPrintReport(
        listRequest,
        this.generateCustomerOnOrderResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateCustomerOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  generateCustomerOnOrderResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  summaryOnClick = (e) => {
    if (e.detail === 1) {
      let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
      let criteria = new AllFabricATSInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
      criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Summary...",
      });
      this.loadCustomerOrderSummaryPage(criteria);
    }
  };

  loadCustomerOrderSummaryPage = (criteria) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.geCustomerOnOrderATSSummary(
        criteria,
        this.loadCustomerOrderSummaryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.inquiryResult != null &&
      response.data.inquiryResult.info != null
    ) {
      const customerSummaryDataList = response.data.inquiryResult.info;
      this.setState({
        customerSummaryDataList: customerSummaryDataList,
        isShowCustomerSummaryPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      let errMsg = "No Data Found";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateCustomerSummaryPdf = (e) => {
    if (e.detail === 1) this.generateCustomerSummaryReport(1);
  };
  generateCustomerSummaryExcel = (e) => {
    if (e.detail === 1) this.generateCustomerSummaryReport(2);
  };
  generateCustomerSummaryReport = (reportType) => {
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let criteria = new AllFabricATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricAtsInfoBean.fabricStyleCode;
    criteria.fabricStyleColorCode = fabricAtsInfoBean.fabricStyleColorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CustomerOnOrderATSSummaryDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
    if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getCustomerOnOrderATSSummaryDetailsReport(
        listRequest,
        this.generateCustomerSummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getCustomerOnOrderATSSummaryDetailsReport(
        listRequest,
        this.generateCustomerSummaryResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateCustomerSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      let reportFilePath = response.data.reportResult.reportFileID;
       let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricVendorAtsInfoBean = new FabricStyleCurrentATSInfoBean();
      fabricVendorAtsInfoBean.companyCode = this.companyCode;
      fabricVendorAtsInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricVendorAtsInfoBean.fabricStyleName = rowData.fabricStyleName;
      fabricVendorAtsInfoBean.fabricStyleColorCode =
        rowData.fabricStyleColorCode;
      fabricVendorAtsInfoBean.vendorOnOrderQuantity =
        rowData.vendorOnOrderQuantity;
      fabricVendorAtsInfoBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ fabricVendorAtsInfoBean: fabricVendorAtsInfoBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendorOnOrder...",
      });
      if (rowData.vendorOnOrderQuantity != 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
        listRequest,
        this.loadPOFabricStatisticsResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPOFabricStatisticsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = new Array();
      let sourceSalesOrderDataList = new Array();
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      }
      if (response.data.orderDetailsResult.sourceOrderDetailLines != null) {
        sourceSalesOrderDataList =
          response.data.orderDetailsResult.sourceOrderDetailLines;
      }
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        sourceSalesOrderDataList: sourceSalesOrderDataList,
        isShowVendorQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(1);
  };
  generateVendorOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(2);
  };
  generateVendorOnOrderReport = (reportType) => {
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorOnOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generateVendorOnOrderPrintReport(
        listRequest,
        this.generateVendorOnOrderResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
    else if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generateVendorOnOrderPrintReport(
        listRequest,
        this.generateVendorOnOrderResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }

  };
  generateVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateVendorOnOrderResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorSummaryOnClick = (e) => {
    if (e.detail === 1) {
      let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
      let criteria = new VendorPurchaseOnOrderSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
      criteria.fabricStyleColorCode =
        fabricVendorAtsInfoBean.fabricStyleColorCode;
      let pageInput = new PageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Vendor Summary...",
      });
      this.loadVendorOrderSummaryPage(listRequest);
    }
  };
  loadVendorOrderSummaryPage = (criteria) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getVendorSummaryOnOrderATSQuantities(
        criteria,
        this.loadVendorOrderSummaryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        const vendorSummaryDataList =
          response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          vendorSummaryDataList: vendorSummaryDataList,
          isShowVendorSummaryPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateVendorSummaryPdf = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(1);
  };
  generateVendorSummaryExcel = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(2);
  };
  generateVendorSummaryReport = (reportType) => {
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorAtsInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorAtsInfoBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorSummaryOnOrderATSDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
     if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getVendorSummaryOnOrderATSDetailsReport(
        listRequest,
        this.generateVendorSummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getVendorSummaryOnOrderATSDetailsReport(
        listRequest,
        this.generateVendorSummaryResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateVendorSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateVendorSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowCustomerQtyPopup: isShowPopup,
      isShowVendorQtyPopup: isShowPopup,
      isShowVendorInTransitQtyPopup: isShowPopup,
      isShowAllLastMonthQtyPopup: isShowPopup,
      isShowLogisticQtyPopup: isShowPopup,
      isShowMonthToDateQtyData: false,
      isShowlast3MonthQtyData: false,
      isShowlast6MonthQtyData: false,
      isShowlast12MonthQtyData: false,
      isShowlast18MonthQtyData: false,
      isShowlast24MonthQtyData: false,
      isShowlast36MonthQtyData: false,
      isShowManualAllocatePopup: false,
      isShowItemCatelogPopup: false,
    });
    this.unSelectAllItem();
  };

  closeAlertSummaryModalCallBack = (isShowPopup) => {
    this.setState({
      isShowCustomerSummaryPopup: isShowPopup,
      isShowVendorSummaryPopup: isShowPopup,
      isShowOnHandQtySummaryPopup: isShowPopup,
      isShowVendorInTransitSummaryPopup: isShowPopup,
      isShowLogisticSummaryPopup: isShowPopup,
    });
  };
  vendorInTransitQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let vendorInTransitBean = new FabricStyleCurrentATSInfoBean();
      vendorInTransitBean.fabricStyleCode = rowData.fabricStyleCode;
      vendorInTransitBean.fabricStyleName = rowData.fabricStyleName;
      vendorInTransitBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      vendorInTransitBean.vendorOnOrderQuantity = rowData.vendorOnOrderQuantity;
      vendorInTransitBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ vendorInTransitBean: vendorInTransitBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.fabricStyleColorCode;
      vendorQtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendor InTransit Qty...",
      });
      if (rowData.inTransitQuantity != 0) {
        this.loadVendorInTransitQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorInTransitQtyListPage = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      PurchaseOrderInTransitService.getVendorPurchaseOrderInTransitDetailsForFabricStyleStatistics(
        listRequest,
        this.loadVendorInTransitResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorInTransitResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inTransitDetailsResult != null) {
      if (response.data.inTransitDetailsResult.inTransitInfoDetails != null) {
        let vendorInTransitQtyDataList =
          response.data.inTransitDetailsResult.inTransitInfoDetails;
        this.setState({
          vendorInTransitQtyDataList: vendorInTransitQtyDataList,
          isShowVendorInTransitQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorInTransitPdf = (e) => {
    if (e.detail === 1) this.generateVendorInTransitReport(1);
  };
  generateVendorInTransitExcel = (e) => {
    if (e.detail === 1) this.generateVendorInTransitReport(2);
  };
  generateVendorInTransitReport = (reportType) => {
    let vendorInTransitBean = this.state.vendorInTransitBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = vendorInTransitBean.fabricStyleCode;
    criteria.colorCode = vendorInTransitBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generateVendorInTransitPrintReport(
        listRequest,
        this.generateInTransitResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  else if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generateVendorInTransitPrintReport(
        listRequest,
        this.generateInTransitResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateInTransitResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateInTransitResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
       let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  vendorInTransitSummaryOnClick = (e) => {
    if (e.detail === 1) {
      let vendorInTransitBean = this.state.vendorInTransitBean;
      let intransitQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      intransitQtyCriteria.companyCode = this.companyCode;
      intransitQtyCriteria.fabricStyleCode =
        vendorInTransitBean.fabricStyleCode;
      intransitQtyCriteria.colorCode = vendorInTransitBean.fabricStyleColorCode;
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestPurchaseOrderInTransitListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = intransitQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading VendorIntransit Summary...",
      });
      this.loadVendorInTransitSummaryPage(listRequest);
    }
  };
  loadVendorInTransitSummaryPage = (listRequest) => {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      PurchaseOrderInTransitService.getInTransitSummaryDetails(
        listRequest,
        this.loadVendorInTransitSummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorInTransitSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.inTransitSummaryDetailsResult != null) {
        if (
          response.data.inTransitSummaryDetailsResult.inTransitSummaryDetails !=
          null
        ) {
          let vendorInTransitSummaryDataList =
            response.data.inTransitSummaryDetailsResult.inTransitSummaryDetails;
          this.setState({
            vendorInTransitSummaryDataList: vendorInTransitSummaryDataList,
            isShowVendorInTransitSummaryPopup: true,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        } else {
          this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
          let errMsg = "No Data Found";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  generateVendorInTransitSummaryPdf = (e) => {
    if (e.detail === 1) this.generateVendorInTransitSummaryReport(1);
  };
  generateVendorInTransitSummaryExcel = (e) => {
    if (e.detail === 1) this.generateVendorInTransitSummaryReport(2);
  };
  generateVendorInTransitSummaryReport = (reportType) => {
    let vendorInTransitSummaryBean = this.state.vendorInTransitBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = vendorInTransitSummaryBean.fabricStyleCode;
    criteria.colorCode = vendorInTransitSummaryBean.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestVendorPurchaseOnOrderListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
      if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getInTransitSummaryDetailsPrintReport(
        listRequest,
        this.generateInTransitSummaryResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.getInTransitSummaryDetailsPrintReport(
        listRequest,
        this.generateInTransitSummaryResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateInTransitSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateInTransitSummaryResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  monthToDateQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.monthToDateQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Month to Date salesInvoice...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForMonthsToDateSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthToDateQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadMonthToDateQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let monthToDateQtyDataList = response.data.result.invoices;
        this.setState({
          monthToDateQtyDataList: monthToDateQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowMonthToDateQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last3MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last3MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 3Months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast3MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast3MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let last3MonthQtyDataList = response.data.result.invoices;
      if (last3MonthQtyDataList != null) {
        this.setState({
          last3MonthQtyDataList: last3MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast3MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateMonthToDateQtyPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 1);
  };
  generateMonthToDateQtyExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 1);
  };
  generateLast3MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 3);
  };
  generateLast3MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 3);
  };
  generateLast6MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 6);
  };
  generateLast6MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 6);
  };
  generateLast12MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 12);
  };
  generateLast12MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 12);
  };
  generateLast18MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 18);
  };
  generateLast18MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 18);
  };
  generateLast24MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 24);
  };
  generateLast24MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 24);
  };
  generateLast36MonthPdf = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(1, 36);
  };
  generateLast36MonthExcel = (e) => {
    if (e.detail === 1) this.generateLastSalesDetailsReport(2, 36);
  };
  generateLastSalesDetailsReport = (reportType, numberOfMonths) => {
    let lastSalesCriteria = this.state.lastSalesCriteria;
    let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = lastSalesCriteria.fabricStyleCode;
    criteria.fabricStyleColorCode = lastSalesCriteria.fabricStyleColorCode;
    criteria.excludedLocationCodes = this.state.criteria.excludedLocationCodes;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
    listRequest.searchCriteria = lastSalesCriteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    listRequest.numberOfMonthsFrom = numberOfMonths;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generate Report...",
    });
     if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generatePopUpLastSalesDetailsATSPrintReport(
        listRequest,
        this.generateLastSalesDetailResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
       else if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.generatePopUpLastSalesDetailsATSPrintReport(
        listRequest,
        this.generateLastSalesDetailResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateLastSalesDetailResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateLastSalesDetailResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last6MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last6MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 6 months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast6MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast6MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last6MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last6MonthQtyDataList: last6MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast6MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last12MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last12MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading last 12 months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast12MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast12MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last12MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last12MonthQtyDataList: last12MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast12MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last18MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last18MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 18 Months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast18MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast18MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last18MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last18MonthQtyDataList: last18MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast18MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last24MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last24MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 24 Months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast24MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast24MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last24MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last24MonthQtyDataList: last24MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast24MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  last36MonthQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.historyDate = rowData.lastSalesDate;
      criteria.onOrderQuantity = rowData.last36MonthsSalesQuantity;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ lastSalesCriteria: criteria });
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 20;
      // pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Last 36 Months Data...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          ReportService.getInvoiceListForLast36MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadLast36MonthQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadLast36MonthQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      if (response.data.result.invoices != null) {
        let last36MonthQtyDataList = response.data.result.invoices;
        this.setState({
          last36MonthQtyDataList: last36MonthQtyDataList,
          isShowAllLastMonthQtyPopup: true,
          isShowlast36MonthQtyData: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  manualAllocateQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let criteria = new ManualInventoryCustomerAllocationSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = rowData.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      criteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      this.setState({ manualAllocateCriteria: criteria });
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestManualInventoryCustomerAllocationListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Manual Allocation List...",
      });
      if (val > 0) {
        if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
          InventoryService.getManualInventoryCustomerAllocationPageList(
            listRequest,
            this.loadManualAllocateQtyResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No Data Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadManualAllocateQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.customerAllocationPageList != null
    ) {
      if (
        response.data.customerAllocationPageList.customerAllocations != null
      ) {
        let manualAllocateDataList =
          response.data.customerAllocationPageList.customerAllocations;
        this.setState({
          manualAllocateList: manualAllocateDataList,
          isShowManualAllocatePopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateManualAllocatePdf = (e) => {
    if (e.detail === 1) this.generateManualAllocateReport(1);
  };
  generateManualAllocateExcel = (e) => {
    if (e.detail === 1) this.generateManualAllocateReport(2);
  };
  generateManualAllocateReport = (reportType) => {
    let manualAllocateCriteria = this.state.manualAllocateCriteria;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new RestManualInventoryCustomerAllocationListRequest();
    listRequest.searchCriteria = manualAllocateCriteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
     if (reportBean.reportType == 1) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpManualCustomerAllocationPrintOutReport(
        listRequest,
        this.generateManualAllocateResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
 else if (reportBean.reportType == 2) {
    if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
      ReportService.downloadPopUpManualCustomerAllocationPrintOutReport(
        listRequest,
        this.generateManualAllocateResponseForExcel,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  }
  };
  generateManualAllocateResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateManualAllocateResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  /* MODULE POPUP */
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowVendorModule: true,
        moduleForPopup: (
          <PopupVendorModule
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowAlert: isDisplayed,
      error_list: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
        locationData: null,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readLocation(locationCode);
  };

  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;

        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  categoryTypeOnChange = (e) => {
    let categoryType = e.target.value;
    this.state.showAutoCompleteCategoryTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCategoryTypeList;
    if (isEmpty(categoryType)) {
      this.state.showAutoCompleteCategoryTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCategoryTypeList;
      let criteria = this.state.criteria;
      criteria.categoryType = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteCategoryTypeList: suggestion,
      });
    } else if (showAutoCompleteList === true && categoryType !== "") {
      this.readCategoryTypeBySearchString(categoryType);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    //this.readDivision(categoryType);
  };
  readCategoryType = (categoryType) => {
    let categoryTypeBean = null;
    this.state.patternTypeCategories.map((ln) => {
      if (ln.code === categoryType) {
        categoryTypeBean = ln;
      }
    });
    if (!isEmpty(categoryTypeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.categoryType = categoryTypeBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
  };
  readCategoryTypeBySearchString = (searchString) => {
    let categoryTypeData = this.state.patternTypeCategories;
    let simpleAutoCompleteList = new Array();
    if (categoryTypeData.length > 0 && categoryTypeData != null) {
      categoryTypeData.map((sp) => {
        let categoryTypeBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(categoryTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      categoryTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };

  categoryTypeEnterKeyEventHandler = (e) => {
    let categoryType = e.target.value;
    this.readCategoryType(categoryType);
    this.setState({
      categoryTypePageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCategoryTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCategoryTypeList: showAutoCompleteList });
  };
  selectAllItem = () => {
    let list = this.state.inquiryDataList;
    list.map((line, i) => {
      line.checked = true;
    });
    this.setState({ selectedItemList: list });
  };
  unSelectAllItem = () => {
    let list = this.state.inquiryDataList;
    list.map((line, i) => {
      line.checked = false;
    });
    this.setState({ selectedItemList: [] });
  };
  catalogCheck = (e, rowData) => {
    rowData.checked = e.target.value;
    let selectedLine = this.state.selectedItemList;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedItemList: selectedLine });
    } else {
      let selectedItemList = this.state.selectedItemList;
      let catList = [];
      for (let item of selectedItemList) {
        if (item.isActive != rowData.isActive) {
          catList.push(item);
          this.setState({ selectedItemList: catList });
        } else if (selectedItemList.length == 1) {
          this.setState({ selectedItemList: [] });
        }
      }
    }
  };
  printCatelog = () => {
    let inquiryDataList = this.state.inquiryDataList;
    let selectedItemList = this.state.selectedItemList;
    let itemList = [];
    for (let list of selectedItemList) {
      let inputBean = new FabricStyleCurrentATSInfoBean();
      inputBean.fabricStyleCode = list.fabricStyleCode;
      inputBean.fabricStyleColorCode = list.fabricStyleColorCode;
      inputBean.fabricStyleName = list.fabricStyleName;
      inputBean.fabricStyleImagePath = list.fabricStyleImagePath;
      inputBean.fabricStyleColorImagePath = list.fabricStyleColorImagePath;
      inputBean.atsYardage = list.atsYardage;
      inputBean.uomCode = list.uomCode;
      inputBean.width = list.width;
      itemList.push(inputBean);
    }
    let catalog_criteria = new ItemCatalogInputCriteria();
    catalog_criteria.companyCode = this.companyCode;
    catalog_criteria.itemCatalogDetails = itemList;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let listRequest = new ItemCatalogInquiryDetailsRequest();
    listRequest.criteria = catalog_criteria;
    listRequest.input = reportBean;
    if (!isEmptyArray(itemList)) {
      if (SecurityAccessManager.AllFabricATSInquiry_IsAccessible()) {
        ReportService.generateItemCatalogInquiryDetails(
          listRequest,
          this.generateCatalogPrintResponse,
          this.generateCatalogPrintPageError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      let errMsg = "No LineSelected";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateCatalogPrintResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  generateCatalogPrintPageError = (error) => {};

  mtdQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Ln#", "lineNumber", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty", "quantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Rolls", "noOfRolls", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  riskvalueHandler = (column, row, risk) => {
    if (risk === 1) {
      return "bg-yellow rish-value";
    } else if (risk === 2) {
      return "bg-pink rish-value";
    } else if (risk === 3) {
      return "bg-red rish-value";
    } else if (risk === 0) {
      return "bg-green rish-value";
    } else {
      return "bg-green rish-value";
    }
  };
  graphValueProvider = (column, rowData) => {
    if (
      parseFloat(rowData.onHandQuantity) >= parseFloat(rowData.receivedQuantity)
    ) {
      return "square-fill-blue";
    } else {
      return "square-partial-yellow";
    }
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")

        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "fabricStyleColorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ClrName", "fabricStyleColorName", true)
        .setStyleDetails("left", "8", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHand", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustOnOrder", "customerOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.customerOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VndrOnOrder", "vendorOnOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Risk", "", true)
        .setGraphDetails(true, this.riskvalueHandler)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("3mnth", "last3MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last3MonthQtyClick, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("6mnth", "last6MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last6MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("12mnth", "last12MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3 ", "wt-3")
        .setClickDetails(true, false, this.last12MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("18mnth", "last18MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last18MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("24mnth", "last24MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last24MonthQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("36mnth", "last36MonthsSalesQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.last36MonthQtyClick, null)
    );

    return columns;
  };
  inquiryOnHandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSKU#", "rollSkuNumber", true)

        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHand", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc#", "aisleInfoText", true)

        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "", true)
        .setGraphDetails(true, this.graphValueProvider)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    let isLoading = this.state.isLoading;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    let customerSummaryDataList = this.state.customerSummaryDataList;
    const logisticSummaryDatalist = this.state.logisticSummaryDatalist;
    let vendorSummaryDataList = this.state.vendorSummaryDataList;
    let inventoryDataBean = this.state.inventoryDataBean;
    let fabricAtsInfoBean = this.state.fabricAtsInfoBean;
    let fabricVendorAtsInfoBean = this.state.fabricVendorAtsInfoBean;
    let lastSalesCriteria = this.state.lastSalesCriteria;
    let vendorInTransitBean = this.state.vendorInTransitBean;
    let manualAllocateCriteria = this.state.manualAllocateCriteria;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL ? "All Item ATS Inquiry" : "All Fabric ATS Inquiry"
          }
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
          // extend_toolbar={
          //   <>
          //     {this.state.isShowItemCatelogButton && (
          //       <Button
          //         className="header_buttons secondary"
          //         size="sm"
          //         onClick={(e) => this.itemCatelog(e)}
          //       >
          //         Item Catelog
          //       </Button>
          //     )}
          //     {this.state.isShowPoInputExcelButton && (
          //       <Button
          //         className="header_buttons secondary"
          //         size="sm"
          //         onClick={(e) => this.poInputExcel(e)}
          //       >
          //         POInputExcel
          //       </Button>
          //     )}
          //   </>
          // }
        />
        <CriteriaView
          {...this.state}
          fabricOnKeydown={this.fabricOnKeydown}
          multiFabricOnKeydown={this.multiFabricOnKeydown}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          multifabricCodeOnChange={this.multifabricCodeOnChange}
          locationCodeOnChange={this.locationCodeOnChange}
          addFabric={this.addFabric}
          addLocation={this.addLocation}
          deleteFabric={this.deleteFabric}
          deleteLocation={this.deleteLocation}
          showHideSecondHeader={this.showHideSecondHeader}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          multiFabricEnterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          categoryTypeOnChange={this.categoryTypeOnChange}
          categoryTypeEnterKeyEventHandler={
            this.categoryTypeEnterKeyEventHandler
          }
          displayAutoCompleteCategoryTypeList={
            this.displayAutoCompleteCategoryTypeList
          }
          displayAutoCompleteMultiFabricList={
            this.displayAutoCompleteMultiFabricList
          }
          parentProductCodeEnterKeyEventHandler={
            this.parentProductCodeEnterKeyEventHandler
          }
          displayAutoCompleteParentProductCodeList={
            this.displayAutoCompleteParentProductCodeList
          }
          onParentProductCodeChange={this.onParentProductCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              label={"Inquiry Data List"}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowItemCatelogPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"ItemCatelog"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <ItemCatelogForm
                {...this.state}
                selectAllItem={this.selectAllItem}
                unSelectAllItem={this.unSelectAllItem}
                catalogCheck={this.catalogCheck}
                printCatelog={this.printCatelog}
              />
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQty"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateOnHandQtyPdf(e)}
          //     >
          //       PDF
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateOnHandQtyExcel(e)}
          //     >
          //       Excel
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.onHandQtySummaryOnClick(e)}
          //     >
          //       Summary
          //     </Button>
          //   </div>
          // }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.uomCode}
                    name={"uomCode"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={inventoryDataBean.totalOnHandQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onHandQtyDataList}
                  columns={this.inquiryOnHandQtyColumns()}
                  label={"OnHandQty Data List"}
                />
              </div>
            </div>
          }
        />

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"CustomerOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateCustomerOnOrderPdf(e)}
          //     >
          //       PDF
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateCustomerOnOrderExcel(e)}
          //     >
          //       Excel
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.summaryOnClick(e)}
          //     >
          //       Summary
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <CustomerOnOrderDetailsForm
                {...this.state}
                fabricAtsInfoBean={this.state.fabricAtsInfoBean}
                customerQtyDataList={this.state.customerQtyDataList}
                handleSortingCustomerQtyChange={
                  this.handleSortingCustomerQtyChange
                }
              />
            </div>
          }
        />

        {/* ------VENDOR ONORDER  POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateVendorOnOrderPdf(e)}
          //     >
          //       PDF
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.generateVendorOnOrderExcel(e)}
          //     >
          //       Excel
          //     </Button>
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.vendorSummaryOnClick(e)}
          //     >
          //       Summary
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <VendorOnOrderDetailsForm
                {...this.state}
                fabricVendorAtsInfoBean={this.state.fabricVendorAtsInfoBean}
                vendorQtyDataList={this.state.vendorQtyDataList}
                sourceSalesOrderDataList={this.state.sourceSalesOrderDataList}
                handleSortingVendorQtyChange={this.handleSortingVendorQtyChange}
                handleSortingSourceSalesOrderChange={
                  this.handleSortingSourceSalesOrderChange
                }
              />
            </div>
          }
        />

        {/* ------LAST SALES DETAIL POPUP ------*/}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowAllLastMonthQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Last Sales Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     {this.state.isShowMonthToDateQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateMonthToDateQtyPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateMonthToDateQtyExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast3MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast3MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast3MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast6MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast6MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast6MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast12MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast12MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast12MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast18MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast18MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast18MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast24MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast24MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast24MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //     {this.state.isShowlast36MonthQtyData && (
          //       <>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast36MonthPdf(e)}
          //         >
          //           PDF
          //         </Button>
          //         <Button
          //           className="header_buttons enterFocus"
          //           size="sm"
          //           onClick={(e) => this.generateLast36MonthExcel(e)}
          //         >
          //           Excel
          //         </Button>
          //       </>
          //     )}
          //   </div>
          // }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={lastSalesCriteria.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={lastSalesCriteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={lastSalesCriteria.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OrderQuantity</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={lastSalesCriteria.onOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
              {this.state.isShowlast3MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last3MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 3 Months Qty Data List"}
                  />
                </div>
              )}
              {this.state.isShowlast6MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last6MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 6 Months Qty Data List"}
                  />
                </div>
              )}
              {this.state.isShowlast12MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last12MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 12 Months Qty Data List"}
                  />
                </div>
              )}
              {this.state.isShowlast18MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last18MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 18 Months Qty Data List"}
                  />
                </div>
              )}
              {this.state.isShowlast24MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last24MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 24 Months Qty Data List"}
                  />
                </div>
              )}
              {this.state.isShowlast36MonthQtyData && (
                <div className="mt-3">
                  <CustomTable
                    data={this.state.last36MonthQtyDataList}
                    columns={this.mtdQtyColumns()}
                    label={"Last 36 Months Qty Data List"}
                  />
                </div>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

class CustomerOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowCustomerOnOrderQtyPopup: isShowPopup,
    });
  };
  customerOnHandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenOrderQty", "onOrderQuantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerPO#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O Date", "salesOrderDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    return columns;
  };
  render() {
    let fabricAtsInfoData = this.props.fabricAtsInfoBean;
    let customerQtyDataList = this.props.customerQtyDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricAtsInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricAtsInfoData.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricAtsInfoData.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Customer OnOrderQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricAtsInfoData.totalCustOnOrderQuantity}
              className="qty_input text-right"
              decimalScale={2}
              name={"totalCustOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="mt-3">
          <CustomTable
            data={customerQtyDataList}
            columns={this.customerOnHandQtyColumns()}
            label={"Customer OnHandQty Data List"}
          />
        </div>
      </div>
    );
  }
}
class VendorOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      modulePopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  handleSortingVendorQtyChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingVendorQtyChange(accessor);
  };
  vendorOnOrderQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(" Vendor#", "vendorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderStopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Open OrderQty", "onOrderQuantity", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  render() {
    let fabricVendorAtsInfoData = this.props.fabricVendorAtsInfoBean;
    let vendorQtyDataList = this.props.vendorQtyDataList;
    let sourceSalesOrderDataList = this.props.sourceSalesOrderDataList;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricVendorAtsInfoData.fabricStyleColorCode}
              disabled={true}
            />
          </Col>
          {/* <Col sm="1">
            <FormLabel>InTransit</FormLabel>
          </Col> */}
          {/* <Col sm="2">
            <InputTextbox
              name="inTransitQuantity"
              type="text"
              value={fabricVendorAtsInfoData.inTransitQuantity}
              disabled={true}
            />
          </Col> */}
          <Col sm="1">
            <FormLabel>VendorQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricVendorAtsInfoData.vendorOnOrderQuantity}
              className="qty_input text-right"
              decimalScale={2}
              name={"vendorOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <div className="mt-3">
              <CustomTable
                data={vendorQtyDataList}
                columns={this.vendorOnOrderQtyColumns()}
                label={"Order Details"}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

class ItemCatelogForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      inquiryDataList: this.props.inquiryDataList,
      selectedItemList: [],
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
  }
  selectAllItem = (e) => {
    if (e.detail === 1) this.props.selectAllItem();
  };
  unSelectAllItem = (e) => {
    if (e.detail === 1) this.props.unSelectAllItem();
  };
  catalogCheck = (e, rowData) => {
    this.props.catalogCheck(e, rowData);
  };
  printCatelog = (e) => {
    if (e.detail === 1) this.props.printCatelog();
  };

  columnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "checked", false)
        .setInputDetails(false, false, true, false, this.catalogCheck, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.props.is3PL ? "Item#" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("COlor#", "fabricStyleColorCode", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ColorName", "fabricStyleColorName", true)
        .setStyleDetails("left")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ATS YD", "atsYardage", true, true)
        .setStyleDetails("right")
    );

    return columns;
  };

  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "",
  //         "isActive",
  //         0,
  //         false, //set hyperlink false
  //         null, //set hyperLink call back null
  //         false,
  //         null
  //       )
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.catalogCheck
  //       )
  //   );
  //   if (this.props.is3PL) {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode")
  //     );
  //   } else {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "FabricStyle",
  //         "fabricStyleCode"
  //       )
  //     );
  //   }
  //   if (this.props.is3PL) {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails("ItemName", "fabricStyleName")
  //     );
  //   } else {
  //     columnList.push(
  //       new DataGridColumnDefinition().setDetails(
  //         "FabricStyleName",
  //         "fabricStyleName"
  //       )
  //     );
  //   }
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Color", "fabricStyleColorCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "ColorName",
  //       "fabricStyleColorName"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("ATSQty", "atsYardage")
  //   );
  //   return columnList;
  // };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  render() {
    let inquiryDataList = this.props.inquiryDataList;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <Row className="d-flex justify-content-center">
          <Col sm="1">
            <Button size="sm" onClick={(e) => this.selectAllItem(e)}>
              {" "}
              SelectAll{" "}
            </Button>
          </Col>
          <Col sm="1">
            <Button size="sm" onClick={(e) => this.unSelectAllItem(e)}>
              {" "}
              UnSelectAll{" "}
            </Button>
          </Col>
          <Col sm="2">
            <Button
              className="header_buttons"
              size="sm"
              onClick={(e) => this.printCatelog(e)}
            >
              {" "}
              Print Catelog{" "}
            </Button>
          </Col>
        </Row>
        <div className="div_default">
          <CustomTable
            data={inquiryDataList}
            columns={this.columnDefinitions()}
            labels={"Item Catelog List"}
          />
        </div>
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.multiFabricCodeRef = React.createRef();
    this.fabricCodeRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.categoryTypeRef = React.createRef();
    this.locationCodeRef = React.createRef();
    this.state = {
      criteria: this.props.criteria,
      locations: [],
      patternTypeCategories: this.props.patternTypeCategories,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    this.initLookupHandlers();
    this.setFocus();
    this.fetchAttributeCache();
  }
  fetchAttributeCache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (!isEmptyArray(attribute_cache.warehouses)) {
      warehouses.map((attr) => {
        this.state.locations.push(attr);
      });
    }
  };
  setFocus() {
    if (this.fabricCodeRef.current != null) {
      this.fabricCodeRef.current.focus();
    }
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.props.locations,
      "Location"
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
    let categoryTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.patternTypeCategories,
      "Category Type"
    );
    this.setState({ categoryTypeLookupHandler: categoryTypeLookupHandler });
  };
  loadPage = () => {
    this.props.loadPage(1);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  multifabricCodeOnChange = (e) => {
    this.props.multifabricCodeOnChange(e);
  };
  locationCodeOnChange = (e) => {
    this.props.locationCodeOnChange(e);
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  onParentProductCodeChange = (e) => {
    this.props.onParentProductCodeChange(e);
  };
  displayAutoCompleteParentProductCodeList = () => {
    this.props.displayAutoCompleteParentProductCodeList();
  };
  parentProductCodeEnterKeyEventHandler = (e) => {
    this.props.parentProductCodeEnterKeyEventHandler(e);
  };
  addFabric = (e) => {
    if (e.detail === 1) {
      this.props.addFabric();
      if (this.multiFabricCodeRef.current != null) {
        this.multiFabricCodeRef.current.clear();
        this.multiFabricCodeRef.current.focus();
      }
    }
  };
  addLocation = (e) => {
    if (e.detail === 1) {
      this.props.addLocation();
      if (this.locationCodeRef.current != null) {
        this.locationCodeRef.current.clear();
        this.locationCodeRef.current.focus();
      }
    }
  };
  deleteFabric = (e, val, line) => {
    this.props.deleteFabric(line);
  };
  deleteLocation = (e, val, line) => {
    this.props.deleteLocation(line);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = () => {
    this.props.displayAutoCompleteFabricList();
  };
  displayAutoCompleteMultiFabricList = () => {
    this.props.displayAutoCompleteMultiFabricList();
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricColorList = () => {
    this.props.displayAutoCompleteFabricColorList();
  };
  multiFabricEnterKeyEventHandler = (e) => {
    this.props.multiFabricEnterKeyEventHandler(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = () => {
    this.props.displayAutoCompleteLocationList();
  };
  categoryTypeEnterKeyEventHandler = (e) => {
    this.props.categoryTypeEnterKeyEventHandler(e);
  };
  displayAutoCompleteCategoryTypeList = () => {
    this.props.displayAutoCompleteCategoryTypeList();
  };
  categoryTypeOnChange = (e) => {
    this.props.categoryTypeOnChange(e);
  };
  fabricColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(this.props.is3PL ? "Item#" : "FabricStyle", "code", true)
        .setStyleDetails("left")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteFabric, <DeleteIcon />)
    );

    return columns;
  };

  locationColumnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "code", true)
        .setStyleDetails("left")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setClickDetails(false, true, this.deleteLocation, <DeleteIcon />)
    );

    return columns;
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) this.props.showHideSecondHeader();
  };
  render() {
    let criteria = this.props.criteria;
    let fabricDatas = this.props.fabricDatas;
    let locationDatas = this.props.locationDatas;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.fabricCodeOnChange}
              ref={this.fabricCodeRef}
              name="fabricStyleCode"
              placeholder="Item"
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              disabled={isDisableFields}
              isMandatory={true}
              isNotFound={this.props.isFabricNotFound}
              onKeyDown={this.props.fabricOnKeydown}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              onChange={this.onChange}
              name="fabricStyleName"
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="0.5">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          {this.props.isTabView ? (
            <Col sm="3">
              <InputTextbox
                onChange={this.onFabricColourCodeChange}
                ref={this.colorCodeRef}
                name="fabricStyleColorCode"
                placeholder="Color"
                value={criteria.fabricStyleColorCode}
                lookupRequired={this.props.isShowColorLookup}
                lookupHandler={this.props.colorLookupHandler}
                enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteFabricColorList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteFabricColorList
                }
                disabled={false}
              />
            </Col>
          ) : (
            <Col sm="3">
              <InputTextbox
                onChange={this.onFabricColourCodeChange}
                ref={this.colorCodeRef}
                name="fabricStyleColorCode"
                placeholder="Color"
                value={criteria.fabricStyleColorCode}
                lookupRequired={this.props.isShowColorLookup}
                lookupHandler={this.props.colorLookupHandler}
                enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteFabricColorList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteFabricColorList
                }
                disabled={isDisableFields}
              />
            </Col>
          )}
          {!this.props.isTabView && (
            <Col sm="1">
              {" "}
              <FormLabel>Category Type</FormLabel>
            </Col>
          )}
          {!this.props.isTabView && (
            <Col sm="1">
              <InputTextbox
                onChange={this.categoryTypeOnChange}
                ref={this.categoryTypeRef}
                name="categoryType"
                placeholder="categoryType"
                value={criteria.categoryType}
                lookupRequired={true}
                lookupHandler={this.state.categoryTypeLookupHandler}
                enterKeyEventHandler={this.categoryTypeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.categoryTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCategoryTypeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCategoryTypeList
                }
                disabled={isDisableFields}
              />
            </Col>
          )}
          {!this.props.isTabView && (
            <Col>
              <CollapseComponent
                isOpen={this.props.isCollapsible_open}
                onClick={(e) => this.showHideSecondHeader(e)}
              />
            </Col>
          )}
        </Row>
        {this.props.isCollapsible_open && !this.props.isTabView && (
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Excluded Fabrics</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.multiFabricCodeRef}
                  name="itemexcludeCode"
                  onChange={this.multifabricCodeOnChange}
                  value={criteria.itemexcludeCode}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.multiFabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.multiFabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteMultiFabricList
                  }
                  showAutoCompleteList={
                    this.props.showAutoCompleteMultiFabricList
                  }
                  disabled={isDisableFields}
                  isMandatory={true}
                  isNotFound={this.props.isMultiFabricNotFound}
                  onKeyDown={this.props.multiFabricOnKeydown}
                />
              </Col>
              <Col sm="1">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addFabric(e)}
                  disabled={isDisableFields}
                >
                  Add
                </Button>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>FabricCode Contains</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.onChange}
                  name="itemCodeContains"
                  placeholder="itemCodeContains"
                  value={criteria.itemCodeContains}
                  disabled={isDisableFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>ShowAllItems</FormLabel>
              </Col>
              <Col className="align-items-left" sm="3">
                <InputCheckbox
                  type="checkbox"
                  name="showNonAvailableItemsFlag"
                  checked={criteria.showNonAvailableItemsFlag}
                  onChange={this.onChange}
                  disabled={isDisableFields}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="4">
                <CustomTable
                  data={fabricDatas}
                  columns={this.fabricColumnDefinitions()}
                  label={"Fabric Data List"}
                />
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

function ATSInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <ATSInquiryModule {...props} name="" /> <br />
    </div>
  );
}

export default ATSInquiry;
